module.exports = __webpack_public_path__ + "static/media/Event-01.5ac65f04.svg";